import ErrorBase from './ErrorBase';

export default function Error500() {
    return (
        <ErrorBase
            title="Oops. There's been a glitch."
            subtitle="We're working to fix the problem and will have things up and running shortly."
            illustration={<Illustration />}
        />
    );
}

function Illustration() {
    return (
        <svg viewBox="0 0 1124.79 690.54">
            <defs>
                <clipPath id="error500__clip-path">
                    <path
                        className="error500__cls-1"
                        d="M786.76 568.95h272.45v41.18H786.76z"
                    />
                </clipPath>
                <clipPath id="error500__clip-path-2">
                    <path
                        className="error500__cls-1"
                        d="M586.36 552.79l-6.19-.08-22.27 69.81 50.85-.11-22.39-69.62z"
                    />
                </clipPath>
                <clipPath id="error500__clip-path-3">
                    <path
                        className="error500__cls-1"
                        d="M155.29 390.53H417a72.28 72.28 0 0172.28 72.28v98.76a2.39 2.39 0 01-2.39 2.39h-331.6a2.39 2.39 0 01-2.39-2.39V392.92a2.39 2.39 0 012.39-2.39z"
                    />
                </clipPath>
                <clipPath id="error500__clip-path-4">
                    <path
                        className="error500__cls-1"
                        d="M329 224.28H171.33v166.25h238.09l.36-87.19c0-43.66-36.18-79.06-80.78-79.06zm59.41 149.77h-197V241.4h127.28c38.48 0 69.69 30.52 69.69 68.17z"
                    />
                </clipPath>
                <style>
                    {
                        '.error500__cls-1,.error500__cls-27,.error500__cls-29,.error500__cls-34,.error500__cls-4,.error500__cls-5{fill:none}.error500__cls-2{fill:#ebfaf6}.error500__cls-14,.error500__cls-21,.error500__cls-29,.error500__cls-30,.error500__cls-33,.error500__cls-34,.error500__cls-4,.error500__cls-5,.error500__cls-7{stroke:#2e3143}.error500__cls-27,.error500__cls-33,.error500__cls-34,.error500__cls-4,.error500__cls-5{stroke-linecap:round;stroke-linejoin:round}.error500__cls-27,.error500__cls-4{stroke-width:2px}.error500__cls-5{stroke-width:6px}.error500__cls-11,.error500__cls-13,.error500__cls-14,.error500__cls-21,.error500__cls-22,.error500__cls-29,.error500__cls-30,.error500__cls-7{stroke-miterlimit:10}.error500__cls-14,.error500__cls-21,.error500__cls-30,.error500__cls-33,.error500__cls-7,.error500__cls-8{fill:#2e3143}.error500__cls-7{stroke-width:5px}.error500__cls-11,.error500__cls-13,.error500__cls-22,.error500__cls-24{fill:#ec486e}.error500__cls-11,.error500__cls-13,.error500__cls-22{stroke:#ec486e}.error500__cls-11{stroke-width:3.26px}.error500__cls-27{stroke:#ebfaf6}.error500__cls-13{stroke-width:2.77px}.error500__cls-14{stroke-width:1.78px}.error500__cls-21{stroke-width:4px}.error500__cls-22{stroke-width:1.27px}.error500__cls-29{stroke-width:10px}.error500__cls-30{stroke-width:2.77px}.error500__cls-33,.error500__cls-34{stroke-width:1.3px}'
                    }
                </style>
            </defs>
            <path
                className="error500__cls-2"
                d="M49.92 631.31c42.78-28.45 55.32-85 55.9-133.77.59-48.46-8.79-96.75-6.44-145.15 3.91-80.87 41.81-159.09 101.1-214.22 102-94.79 258.88-128.86 391.74-90.1 16.14 4.71 34.7 13.91 33.69 33.65-.51 9.94-5.9 21.34.6 28.88 3.18 3.7 8.28 5 13.06 5.89C726.4 133 811.88 91.75 898.85 103.05c83.61 10.86 96.65 117.86 74 184.45-8.37 24.53-21.14 48.8-19.38 74.66 2.64 39 36.44 67.28 58.12 99.8 35.51 53.26 44.64 114.07 13.33 169.91"
            />
            <path
                d="M1017.58 487.05h-51.26v-40.27l-26 .28v-61.64h-57.06v62.24l-32.75.35V337.17h-10.26V312.3h-19.11v18.43h-22.68V436l-28.65 18.73h-20.54v18.11h-4.53v-40.49h-35.1v-21.49h-73.55l-10.27 1.54v7.06h-29.36v-86.59h-11v-8h-28.88v8.29h-11.7v127.13h-24.36V440h-32.47l-13.37 5.22v17.5h-15.52V456h-23.88v11.06S415.69 487 413.36 490v-34.55l-8.92-16.1a1.15 1.15 0 00-2.23-.11l-8.1 16.21v40.05l-14.11-.15V394h-27.36v-86.45h-74.45v24h-52.91v-53.91h-26.8v-6h-13.74v6h-5.5v-13.1H165.5v13.1h-21.3v191.13h-30.61v163.1h904z"
                fill="#c0efe8"
            />
            <path className="error500__cls-4" d="M12.42 632.33h1069.07" />
            <path
                className="error500__cls-5"
                d="M760.54 264.7c-6.09 3.3-12.65 8.5-13.78 15.94-1.51 10-2.36 20-3 30.05"
            />
            <path
                className="error500__cls-4"
                d="M408.83 391.88l162.9 13.17-3.57-152.43 102.15-16.13.54-73.2 56.8-25.64 11.46-33.73"
            />
            <path
                className="error500__cls-4"
                d="M489.3 548.47c-1.54-1.55 5.71-232.23 5.71-232.23l133.38-8.16 2.67-110.18 67.76-11.9 13.71-58 33.12-21.38"
            />
            <path
                d="M351.89 323c-11.8 0-21.37 19.65-21.37 43.88s9.57 43.88 21.37 43.88 21.37-19.65 21.37-43.88S363.69 323 351.89 323zm0 79.41c-10.14 0-18.36-16.88-18.36-37.7S341.75 327 351.89 327s18.36 16.87 18.36 37.69-8.25 37.73-18.36 37.73z"
                strokeWidth={7}
                strokeMiterlimit={10}
                stroke="#00a594"
                fill="#00a594"
            />
            <path
                className="error500__cls-7"
                d="M338.3 357.91h.15m.22-3.57a10.49 10.49 0 011.33-20.92l.23-3.57A14.28 14.28 0 00325.3 343a14.06 14.06 0 0013 14.92z"
            />
            <path
                className="error500__cls-8"
                d="M327.36 348.82c-6.23.06-13.24.18-16.83.16-5.26 0-10.52 0-17.28-.09-2.76 0-5.64-.05-8.6-.12-13.7-.34-29.11-1.73-42.17-8.93a6.25 6.25 0 016-10.94c13.12 7.23 30 7.37 44.84 7.49 6.74.06 12 .08 17.22.1s10.52 0 17.28.1"
            />
            <path
                d="M300 294.47a41.28 41.28 0 00-82.36 0v.8l-.11 123.86h82.59L300 295z"
                strokeWidth={2.08}
                strokeMiterlimit={10}
                stroke="#00a594"
                fill="#00a594"
            />
            <path
                d="M275.87 318a10.19 10.19 0 0011.5 1.64"
                strokeWidth={2.01}
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke="#2e3143"
                fill="none"
            />
            <circle
                className="error500__cls-8"
                cx={273.18}
                cy={302.76}
                r={6.83}
            />
            <circle
                className="error500__cls-8"
                cx={291.97}
                cy={303.19}
                r={6.83}
            />
            <path
                className="error500__cls-8"
                d="M359.06 363.72c-6.73.11-12 .22-17.21.32s-10.52.23-17.28.33c-2.76.05-5.64.1-8.6.1-13.71 0-29.14-1-42.37-7.88a6.25 6.25 0 115.76-11.09c13.28 6.9 30.13 6.62 45 6.38 6.73-.11 12-.22 17.21-.33s10.52-.22 17.28-.33"
            />
            <path
                className="error500__cls-11"
                d="M218.65 288.05c0-21.57 17.89-39.06 40-39.06s40 17.49 40 39.06"
            />
            <path
                className="error500__cls-11"
                d="M283.38 277.52h19.84a8.84 8.84 0 018.84 8.84v.08h-28.68v-8.93.01z"
            />
            <path
                className="error500__cls-7"
                d="M367 367.55a10.49 10.49 0 010-21V343a14.28 14.28 0 00-14 14.06 14.07 14.07 0 0013.92 14.07z"
            />
            <path
                d="M225.36 276.34l.24-.7a35.67 35.67 0 0166.71 0"
                strokeWidth={1.89}
                stroke="#ebfaf6"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                className="error500__cls-4"
                d="M487.76 551.13L754.88 90.72a.2.2 0 00-.3-.25L408.05 391.88z"
            />
            <path
                className="error500__cls-13"
                d="M156.76 391.88h259.62a71.38 71.38 0 0171.38 71.38v96.94a2.36 2.36 0 01-2.36 2.36H156.76a2.36 2.36 0 01-2.36-2.36v-166a2.36 2.36 0 012.36-2.36z"
            />
            <rect
                className="error500__cls-14"
                x={119.02}
                y={573.82}
                width={404.13}
                height={82.85}
                rx={41.43}
            />
            <circle
                className="error500__cls-2"
                cx={179.95}
                cy={615.57}
                r={18.1}
            />
            <circle
                className="error500__cls-2"
                cx={249.95}
                cy={615.57}
                r={18.1}
            />
            <circle
                className="error500__cls-2"
                cx={319.95}
                cy={615.57}
                r={18.1}
            />
            <circle
                className="error500__cls-2"
                cx={389.95}
                cy={615.57}
                r={18.1}
            />
            <circle
                className="error500__cls-2"
                cx={459.95}
                cy={615.57}
                r={18.1}
            />
            <rect
                x={122.25}
                y={577.33}
                width={397.42}
                height={76.4}
                rx={38.2}
                strokeWidth={1.52}
                stroke="#ec486e"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                strokeMiterlimit={10}
                stroke="#00a594"
                fill="#00a594"
                strokeWidth={2}
                d="M637.83 526.12h203.06v104.2H637.83z"
            />
            <path
                strokeWidth={1.95}
                fill="#2e3143"
                strokeMiterlimit={10}
                stroke="#2e3143"
                d="M804.46 573.77h12.1v84.41h-12.1z"
            />
            <path
                strokeWidth={1.96}
                fill="#2e3143"
                strokeMiterlimit={10}
                stroke="#2e3143"
                d="M1029.45 572.88h12.1v85.3h-12.1z"
            />
            <path
                strokeWidth={1.61}
                stroke="#ec486e"
                fill="#ec486e"
                strokeMiterlimit={10}
                d="M787.46 569.69h270.96v39.71H787.46z"
            />
            <g clipPath="url(#error500__clip-path)">
                <path
                    className="error500__cls-21"
                    d="M821.47 552.14l-55.36 55.36M851.78 560.45l-55.35 55.35M891.78 560.45l-55.35 55.35M931.78 560.45l-55.35 55.35M971.78 560.45l-55.35 55.35M1011.78 560.45l-55.35 55.35M1051.78 560.45l-55.35 55.35M1091.78 560.45l-55.35 55.35"
                />
            </g>
            <rect
                className="error500__cls-22"
                x={551.29}
                y={622.89}
                width={64.08}
                height={7.78}
                rx={0.97}
            />
            <path
                className="error500__cls-22"
                d="M580.62 553.37l-21.91 68.69h49.24l-22.08-68.69h-5.25z"
            />
            <g clipPath="url(#error500__clip-path-2)">
                <path
                    className="error500__cls-14"
                    d="M560.33 585.69h47.62v14.62h-47.62z"
                />
            </g>
            <path
                className="error500__cls-24"
                d="M206.7 546.53h226.49V573H206.7z"
            />
            <path
                className="error500__cls-4"
                d="M753.7 91.64v116.38l-86.11 113.39M753.7 208.02l114.57 113.39"
            />
            <g clipPath="url(#error500__clip-path-3)">
                <path
                    strokeWidth={2.01}
                    fill="#2e3143"
                    strokeMiterlimit={10}
                    stroke="#2e3143"
                    d="M151.5 551.13h338.22v12.11H151.5z"
                />
            </g>
            <path
                className="error500__cls-24"
                d="M666.42 320.87h203.06v104.74H666.42z"
            />
            <path
                className="error500__cls-13"
                d="M328.35 224.28H172.9v167.6h235.15V304a79.7 79.7 0 00-79.7-79.72zm58.59 151H192.63V241.54h125.58a68.73 68.73 0 0168.73 68.73z"
            />
            <path
                className="error500__cls-27"
                d="M173.73 417h256.86a32.62 32.62 0 0132.61 32.6v81.62a1.83 1.83 0 01-1.83 1.83H173.73a1.83 1.83 0 01-1.83-1.83V418.81a1.83 1.83 0 011.83-1.81z"
            />
            <path
                className="error500__cls-2"
                d="M189.72 434.01h8.65v84.92h-8.65zM219.72 434.01h8.65v84.92h-8.65zM249.72 434.01h8.65v84.92h-8.65zM279.72 434.01h8.65v84.92h-8.65zM309.72 434.01h8.65v84.92h-8.65zM339.72 434.01h8.65v84.92h-8.65zM369.72 434.01h8.65v84.92h-8.65zM399.72 434.01h8.65v84.92h-8.65zM429.72 434.01h8.65v84.92h-8.65z"
            />
            <g clipPath="url(#error500__clip-path-4)">
                <path
                    className="error500__cls-8"
                    d="M170.25 385h240.67v7.94H170.25z"
                />
            </g>
            <path
                className="error500__cls-29"
                d="M795.9 315.81c11.34 11.16 18 31.08 15.73 46.82"
            />
            <path
                className="error500__cls-8"
                d="M801.88 364.3a9 9 0 1117.88 2.54"
            />
            <path
                className="error500__cls-29"
                d="M769.56 315.58c11.34 11.16 18 31.08 15.73 46.82"
            />
            <circle
                className="error500__cls-8"
                cx={806.14}
                cy={203.37}
                r={11.56}
            />
            <circle
                className="error500__cls-8"
                cx={757.8}
                cy={202.02}
                r={11.56}
            />
            <path
                className="error500__cls-8"
                d="M777.97 253.68h8.23v6.78h-8.23z"
            />
            <path
                className="error500__cls-30"
                d="M837.42 219.2a5.8 5.8 0 01-11.58-.66l-2-.11a7.91 7.91 0 007.33 8.21 7.79 7.79 0 008.21-7.25z"
            />
            <path
                className="error500__cls-5"
                d="M796 265.44c6.74-.05 14-.42 19.39-4.4a24.27 24.27 0 006.13-7c4.93-8 7.09-17.33 9.18-26.48"
            />
            <path
                strokeWidth={1.72}
                strokeMiterlimit={10}
                stroke="#00a594"
                fill="#00a594"
                d="M758.54 262.52l19.28-3.18 8.25-.07 19.56 3.25v57.41h-47.02l-.07-57.41z"
            />
            <circle cx={782.09} cy={222.33} r={32.16} fill="#00a594" />
            <circle
                className="error500__cls-8"
                cx={771.73}
                cy={217.13}
                r={6.24}
            />
            <path
                className="error500__cls-33"
                d="M766.97 210.64l2.9 4.5M773.9 215.49l2.25-4.85M771.73 214.81v-5.1"
            />
            <circle
                className="error500__cls-8"
                cx={794.58}
                cy={217.13}
                r={6.24}
            />
            <path
                className="error500__cls-33"
                d="M789.83 210.64l2.89 4.5M796.76 215.49l2.25-4.85M794.58 214.81v-5.1M798.54 204.77a5 5 0 014 3.17"
            />
            <path
                className="error500__cls-34"
                d="M769.24 204a6.75 6.75 0 00-4.71 3.32M772 228.94a3.23 3.23 0 004.59 1.63"
            />
            <path
                className="error500__cls-27"
                d="M760.56 266.06h42M761.08 271.96h41.43v43.85h-41.43z"
            />
            <circle
                className="error500__cls-2"
                cx={795.9}
                cy={292.1}
                r={1.79}
            />
            <path
                className="error500__cls-30"
                d="M737.88 319.47a5.8 5.8 0 0111.6 0h2a7.78 7.78 0 00-15.56 0z"
            />
            <path
                className="error500__cls-8"
                d="M775.54 364.07a9 9 0 1117.88 2.54M813.35 197.85l11.13-11.13"
            />
            <path className="error500__cls-34" d="M813.35 197.85l10.01-10.01" />
            <path
                className="error500__cls-8"
                d="M824.48 189.07a1.66 1.66 0 10-2.35 0 1.66 1.66 0 002.35 0zM751.81 196.02l-11.13-11.13"
            />
            <path
                className="error500__cls-34"
                d="M751.81 196.02l-10.02-10.01"
            />
            <path
                className="error500__cls-8"
                d="M743 184.89a1.66 1.66 0 100 2.35 1.66 1.66 0 000-2.35z"
            />
        </svg>
    );
}
